// removed by extract-text-webpack-plugin
module.exports = {"pager":"_3zcG0fMLWZ_Yf61MIK_-zg","page-list":"LHNiVzPxkMbVe0QvjRTXA","spin":"_1L8xthtsn7tcGOPy6JMWPJ"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/Pager/styles.scss
// module id = 909
// module chunks = 18